<form [formGroup]="form">
  <div class="row">
    <ng-container *ngFor="let field of formFields">
      <div [ngClass]="field.wrapperClass" *ngIf="isFieldVisible(field)" class="mb-4">
        <div class="d-flex flex-column col-md-12" [ngClass]="field.customClass">
          <label [hidden]="field.type === 'input-list' || field.hideLabel" class="form-label general-text-6" [ngClass]="!field.name ? 'addCustomeCss' : ''">
            {{ field.name }}
            <span *ngIf="field.validations?.required" class="text-danger">*</span>
            <span *ngIf="field.isLoading" class="spinner-border spinner-border-sm mx-2" role="status"
              aria-hidden="true">
            </span>
            <span *ngIf="field.labelDescription" class="no-item"> {{ field.labelDescription }} </span>
          </label>
          <ng-container [ngSwitch]="field.type">
            <!-- Section Label-->
            <ng-container *ngSwitchCase="'section-label'">
              <span [ngClass]="field.customClass">{{field.value}}</span>
            </ng-container>

            <!-- TEXT INPUT -->
            <ng-container *ngSwitchCase="'text-input'">
              @if(!field.autocompleteOptions?.length) {
              <input type="text" class="form-control" [formControlName]="field.key"
                [placeholder]="field.placeholder || ''" />
              } @else {
              <app-autocomplete-input [options]="field.autocompleteOptions" [value]="field.value"
                [placeholder]="field.placeholder || ''" (optionSelected)="onAutoCompleteChange($event, field)"
                [isPlain]="true">
              </app-autocomplete-input>
              }
              @if(getValidationError(field.key)) {
                <span class="err-msg">{{ getValidationError(field.key) }}</span>
              }
            </ng-container>
            <!-- CHECKBOX -->
            <ng-container *ngSwitchCase="'checkbox'">
              <div class="form-check d-flex align-items-center">
                <input class="form-check-input" type="checkbox" [id]="field.key" [formControlName]="field.key" />
                <label class="form-check-label general-text-6" [for]="field.key">
                  {{ field.label || field.name || field.placeholder }}
                </label>
                <img
                  *ngIf="field.tooltip"
                  class="field-info-icon"
                  [src]="'images/virtusa-icons/info-dark.svg' | assetUrl"
                  alt="info"
                  [matTooltip]="field.tooltip"
                  matTooltipPosition="above"
                  matTooltipClass="field-info-tooltip"
                />
              </div>
            </ng-container>

            <!-- TOGGLE SWITCH -->
            <ng-container *ngSwitchCase="'toggle'">
              <div class="d-flex align-items-center justify-content-between toggle-wrapper">
                <label class="form-check-label general-text-6" [for]="field.key">
                  {{ field.label || field.name }}
                </label>
                <div class="form-check form-switch">
                  <input class="form-check-input custom-toggle" [formControlName]="field.key" type="checkbox" role="switch" [id]="field.key" [attr.aria-checked]="form.get(field.key)?.value ? true : false" />
                </div>
              </div>
            </ng-container>
            
            <ng-container *ngSwitchCase="'password-input'">
              <div class="d-flex align-items-center">
              <div class="position-relative flex-grow-1">
                <input [type]="showPassword[field.key] ? 'text' : 'password'" class="form-control pe-5"
                  [formControlName]="field.key" [placeholder]="field.placeholder || ''"
                  (focus)="maskedFields[field.key] && unmaskField(field.key)" />
                <span class="material-symbols-outlined eye-icon"
                  [style.pointer-events]="maskedFields[field.key] ? 'none' : 'auto'"
                  [style.opacity]="maskedFields[field.key] ? '0.4' : '1'"
                  (click)="togglePassword(field.key)" (keydown)="togglePassword(field.key)"
                  [title]="maskedFields[field.key] ? 'Click field to enter a new value' : (showPassword[field.key] ? 'Hide' : 'Show')">
                  {{ showPassword[field.key] ? 'visibility_off' : 'visibility' }}
                </span>
              </div>
               <img *ngIf="maskedFields[field.key]" src="assets/images/virtusa-icons/info-gray.png" alt="info" class="info-icon mx-2" title="This field is masked due to security purposes, still you can edit and make changes" />
            </div>
            </ng-container>

            <!-- NUMBER INPUT -->
            <ng-container *ngSwitchCase="'number-input'">
              <input type="number" class="form-control" [formControlName]="field.key" />
            </ng-container>

            <!-- TEXTAREA -->
            <textarea *ngSwitchCase="'textarea'" class="form-control text-area" [formControlName]="field.key"></textarea>

            <!-- SELECT - DROPDOWN (API may also send type: "dropdown") -->
            <ng-container *ngSwitchCase="'select'">
              <select [formControlName]="field.key" aria-placeholder="Select an option" class="form-select"
                (change)="onSelectChange(field)">
                <option value="" disabled hidden *ngIf="field.placeholder">
                  {{ field.placeholder }}
                </option>
                @for (item of field?.options; track item?.value) {
                <option [value]="item.value" [disabled]="item.disabled">{{ item.label || item.value }}</option>
                }
              </select>
            </ng-container>
            <ng-container *ngSwitchCase="'dropdown'">
              <select [formControlName]="field.key" aria-placeholder="Select an option" class="form-select"
                (change)="onSelectChange(field)">
                <option value="" disabled hidden *ngIf="field.placeholder">
                  {{ field.placeholder }}
                </option>
                @for (item of field?.options; track item?.value) {
                <option [value]="item.value" [disabled]="item.disabled">{{ item.label || item.value }}</option>
                }
              </select>
            </ng-container>

            <!-- param_ui_object -->
            <ng-container *ngSwitchCase="'param_ui_object'">
              <select [formControlName]="field.key" aria-placeholder="Select an option" class="form-select"
                (change)="onSelectChange(field)">
                @for (item of field?.options; track item?.value) {
                <option [value]="item.value">{{ item.label }}</option>
                }
              </select>

              @if (field.uiParams | keyvalue; as params) {
                <div class="parameters-grid">
                  @for (param of params; track param.key) {
                    <div class="parameter-row">
                      <div class="parameter-col">
                        <input type="text" class="form-control" [value]="param.key" [disabled]="true" />
                      </div>
                      <div class="parameter-col">
                        @if (!field.autocompleteOptions?.length) {
                          <input type="text" class="form-control"
                                 [value]="field.uiParams[$any(param.key)]"
                                 (input)="field.uiParams[$any(param.key)] = $any($event.target).value" />
                        }
                        @else {
                          <app-autocomplete-input
                            [options]="field.autocompleteOptions"
                            [value]="field.uiParams[$any(param.key)]"
                            (optionSelected)="onAutoCompleteChangeParam($event, field, param)">
                          </app-autocomplete-input>
                        }
                        <!-- <input type="text" class="form-control" [value]="field.uiParams[$any(param.key)]" (input)="field.uiParams[$any(param.key)] = $any($event.target).value" /> -->
                      </div>
                    </div>
                  }
                </div>
              }
              
              
              <!-- <div class="parameters-grid" *ngIf="field.parameters.length>0">
                <div class="parameter-row" *ngFor="let param of field.parameters; let i = index">
                  <div class="parameter-col">
                    <input type="text" class="form-control" [value]="param.key" [disabled]="'true'" />
                  </div>
              
                  <div class="parameter-col">
                    <input type="text" class="form-control" [value]="param.value" />
                  </div>
                </div>
              </div> -->
            </ng-container>

            
            <!-- section-select dropdown -->
            <ng-container *ngSwitchCase="'section-select'" >
              <app-dropdown-with-sections
              [config]="field.config"
              [fields]="field.fields"
              [selectedValue]="field.value"
              (onSelect)="onSelect($event, field)"
            ></app-dropdown-with-sections>
            </ng-container>

            <!-- menu-dropdown -->
            <ng-container *ngSwitchCase="'menu-dropdown'">
              <app-menu-dropdown
                [selectedValue]="field.value"
                [placeholderText]="field.placeholder || 'Select an option'"
                [data]="field.options"
                (onSelect)="onMenuDropdownSelect($event, field)"
              >
              </app-menu-dropdown>
            </ng-container>

            <!-- TABLE / TABLE-INPUT (key-value) -->
            <div [ngSwitch]="field.type === 'table-input' ? 'table' : field.type">
              <ng-container *ngSwitchCase="'table'">
                <div class="mx-3 add-btn"
                  [class.add-btn--disabled]="hasDraftRow(field)"
                  [attr.title]="hasDraftRow(field) ? 'Save the current row before adding a new one' : null"
                  (click)="addNew(field)"
                  (keydown.enter)="addNew(field)">
                  <img src="assets/images/virtusa-icons/add-icon.svg" alt="add">
                  <span> Add New {{ field.name }} </span>
                </div>
                <div class="form-group table-container" [formGroupName]="field.key" *ngIf="tableData[field.key]">
                  <app-zorro-table
                    [tableId]="'dynamic-key-value-table'"
                    [columns]="tableData[field.key].columns"
                    [data]="tableData[field.key].rows"
                    [autocompleteOptions]="autocompleteOptionsByKey"
                    (handleActions)="handleTableActions($event, field)"
                  ></app-zorro-table>
                </div>
              </ng-container>
            </div>
            <!-- RADIO BUTTON -->
            <ng-container *ngSwitchCase="'radio'">
              <div class="d-grid gap-3 d-md-flex flex-wrap">
                <div *ngFor="let option of field.options" class="form-check me-3">
                  <input type="radio" class="form-check-input" [id]="option.value" [formControlName]="field.key"
                    [value]="option.value" />
                  <label class="form-check-label general-text-6" [for]="option.value">
                    {{ option.label }}
                  </label>
                </div>
              </div>
            </ng-container>

            <!-- Date Picker -->
            <ng-container *ngSwitchCase="'date-picker'">
              <!-- <p-calendar [formControlName]="field.key" [style]="{'width':'70%'}" [inputStyle]="{'width':'70%'}" [showIcon]="true" class="small-calendar" dateFormat="yy-mm-dd"
                (onSelect)="
                form.controls[field.key].setValue(getFormattedDate($event))
              ">
              </p-calendar> -->
              <nz-date-picker [formControlName]="field.key" [nzDisabledDate]="getDisabledDateFn(field)"></nz-date-picker>
            </ng-container>

            <!-- File upload -->
            <ng-container *ngSwitchCase="'file-upload'">
              <app-file-upload class="mb-2" [value]="field.value" [data]="field?.configs"
                (filesSelected)="form.controls[field.key].setValue(handleFilesSelected($event))"></app-file-upload>
            </ng-container>

            <!-- BOOLEAN - SWITCH -->
            <ng-container *ngSwitchCase="'switch'">
              <div class="d-flex">
                <div class="v-center">
                  <label class="form-label"> No </label>
                </div>
                <div class="form-check form-switch mx-2">
                  <input class="form-check-input" [formControlName]="field.key" type="checkbox" role="switch"
                    id="flexSwitchCheckChecked" checked />
                </div>
                <div class="v-center">
                  <label class="form-label"> Yes </label>
                </div>
              </div>
            </ng-container>

            <!-- Input List -->
            <ng-container *ngSwitchCase="'input-list'">
              <fieldset class="p-3 rounded mt-2">
                <legend class="custom-legend">
                  {{ field.name }}
                  <span *ngIf="field.isLoading" class="spinner-border spinner-border-sm mx-2" role="status"
                    aria-hidden="true">
                  </span>
                </legend>
                <div *ngFor="let item of field.list">
                  <div class="v-center">
                    <label class="form-label"> {{ item.label }} </label>
                    @if(!item.autocompleteOptions?.length) {
                    <input type="text" class="form-control" [formControlName]="item.id" />
                    } @else {
                    <app-autocomplete-input [options]="item.autocompleteOptions" [value]="item.value"
                      (optionSelected)="onAutoCompleteChange($event, item, true)" [isPlain]="true">
                    </app-autocomplete-input>
                    }
                  </div>
                </div>
              </fieldset>
            </ng-container>

            <!-- card list select -->
            <ng-container *ngSwitchCase="'select-card'">
              <div class="select-card-container">
                <div
                class="select-card"
                *ngFor="let option of field.options"
                [class.active]="form.controls[field.key].value === option.value"
                (click)="onSelectCard(field, option)"
                (keydown.enter)="onSelectCard(field, option)"
                >
                  <img
                    class="select-card-icon"
                    [src]="option.icon | assetUrl"
                    [alt]="option.label"
                  />
                  <div class="select-card-label">
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- label-only card select -->
            <ng-container *ngSwitchCase="'label-card'">
              <div class="select-card-container">
                <div
                class="label-card"
                *ngFor="let option of field.options"
                [class.active]="form.controls[field.key].value === option.value"
                (click)="onSelectCard(field, option)"
                (keydown.enter)="onSelectCard(field, option)"
                >
                  <div class="label-card-text">
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- MULTI-SELECT (UploadFiles / any multi-value field) -->
            <ng-container *ngSwitchCase="'multi-select'">
              <nz-select
                class="w-100"
                nzMode="multiple"
                [formControlName]="field.key"
                [nzPlaceHolder]="field.placeholder || 'Select files'"
                [nzLoading]="field.isLoading"
                [nzDisabled]="field.isDisabled || field.disabled || false"
                nzShowSearch
                nzAllowClear
              >
                <nz-option
                  *ngFor="let opt of field.options"
                  [nzValue]="opt.value"
                  [nzLabel]="opt.label"
                ></nz-option>
              </nz-select>
              <span class="no-item" *ngIf="!field.isLoading && field.labelDescription">
                {{ field.labelDescription }}
              </span>
            </ng-container>

          </ng-container>
        </div>
        <!-- VALIDATION -->
        <div *ngIf="
            form.controls[field.key]?.invalid &&
            (form.controls[field.key]?.dirty ||
              form.controls[field.key]?.touched)
          " class="err-msg">
          <div *ngIf="isError(field.key) as errorMessage">{{ errorMessage }}</div>
        </div>
      </div>
    </ng-container>
  </div>
</form>